import Vue from 'vue';
let values = sessionStorage.getItem('user_info');

if (values) {
  try {
    values = JSON.parse(values, null);
  } catch (e) {}
}

export default {
  namespaced: true,
  state: {
    userInfo: values || {},
    language: localStorage.getItem('language') || 'zh-CN'
  },
  mutations: {
    setState(state, obj) {
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
    setAppid(state, appid) {
      state.userInfo.appid = appid
    }
  },
  actions: {
    logout({
      commit,
      state,
      dispatch
    }) {
      dispatch('tagsView/delAllViews', null, {
        root: true
      })
      commit('setState', {
        userInfo: {},
      })
      sessionStorage.removeItem('user_info')
      Vue.prototype.$bus.$nextTick(() => {
        location.reload();
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js